import {
    CreateProjectPayload,
    DocumentData,
    Reference,
    RefineTextPayload,
    TextSuggestion,
    UpdateProjectPayload,
    UploadDocumentPayload,
} from '../types/projectTypes';

import { createAsyncThunk } from '@reduxjs/toolkit';
import { CurrentProject } from '../types/projectTypes';
import { axiosInstance } from './axiosInstance';
import { ProjectResponse } from '../types/projectTypes';
import { AxiosError } from 'axios';
import { FetchProjectPayload, FetchProjectResponse } from '../types/projectTypes';
import { FetchProjectResult } from '../types/projectTypes';
import {
    RecentProjectsAttributes,
    RecentProjectsApiResponse,
    GenerateContentResponse,
    GeneratedContent,
} from '../types/imagesType';
import { ScriptData, UpdateProjectTextPayload } from '../types/scriptTypes';

import axios from 'axios';

export const createProject = createAsyncThunk<
    CurrentProject,
    CreateProjectPayload,
    { rejectValue: string }
>('project/createProject', async (projectDetails, { rejectWithValue }) => {
    try {
        const response = await axiosInstance.post<ProjectResponse>('/projects', {
            data: {
                type: 'projects',
                attributes: {
                    title: projectDetails.title,
                    prompt: projectDetails.prompt,
                    kind: projectDetails.kind,
                    category: projectDetails.category,
                    industry: projectDetails.industry,
                    content_type: projectDetails.content_type,
                    goal: projectDetails.goal,
                    tone: projectDetails.tone,
                    cta: projectDetails.cta,
                },
            },
        });

        const { data } = response.data;

        const transformedData: CurrentProject = {
            id: data.id,
            title: data.attributes.title,
            category: data.attributes.category,
            industry: data.attributes.industry,
            content_type: data.attributes.content_type,
            goal: data.attributes.goal,
            tone: data.attributes.tone,
            kind: projectDetails.kind,
            prompt: projectDetails.prompt,
        };

        console.log('Transformed Data', transformedData);
        return transformedData;
    } catch (error) {
        console.log('Error occurred while creating the project');
        if (axios.isAxiosError(error) && error.response) {
            return rejectWithValue(error.response.data.message);
        }
        return rejectWithValue('An unexpected error occurred');
    }
});

export const updateProject = createAsyncThunk<
    { project: CurrentProject; script: ScriptData },
    UpdateProjectPayload,
    { rejectValue: string }
>('project/updateProject', async (projectDetails, { rejectWithValue }) => {
    try {
        const response = await axiosInstance.patch<ProjectResponse>(
            `/projects/${projectDetails.id}`,
            {
                data: {
                    type: 'projects',
                    id: projectDetails.id,
                    attributes: {
                        ...(projectDetails.kind && { kind: projectDetails.kind }),
                        ...(projectDetails.title && { title: projectDetails.title }),
                        ...(projectDetails.category && { category: projectDetails.category }),
                        ...(projectDetails.industry && { industry: projectDetails.industry }),
                        ...(projectDetails.content_type && {
                            content_type: projectDetails.content_type,
                        }),
                        ...(projectDetails.post_type && { post_type: projectDetails.post_type }),
                        ...(projectDetails.prompt && { prompt: projectDetails.prompt }),
                        ...(projectDetails.goal && { goal: projectDetails.goal }),
                        ...(projectDetails.tone && { tone: projectDetails.tone }),
                        ...(projectDetails.link && { link: projectDetails.link }),
                        ...(projectDetails.voice && { voice: projectDetails.voice }),
                        ...(projectDetails.schedule && { schedule: projectDetails.schedule }),
                    },
                    relationships: projectDetails.image
                        ? {
                              image: {
                                  type: 'images',
                                  id: projectDetails.image.id,
                              },
                          }
                        : {
                              image: null,
                          },
                },
            },
        );

        const { data, included } = response.data;
        const scriptItem = included?.find((item) => item.type === 'script_texts');
        const scriptAttributes = scriptItem?.attributes as {
            title: string;
            preview: string;
            body: string;
        };

        // const imageItem = included?.find((item) => item.type === 'image_projects');
        // const imageAttributes = imageItem?.attributes as
        //     | {
        //           url: string;
        //           original_url: string;
        //           canvas_color: CanvasColor;
        //           visual_settings: VisualSettings;
        //           visual_effects: VisualEffects;
        //           transformation: Transformation;
        //           prompt: string;
        //           is_realism_mode: boolean;
        //           reference_settings: ReferenceSettings;
        //           creativity_level: number;
        //       }
        //     | undefined;

        const transformedData: CurrentProject = {
            id: data.id,
            title: data.attributes.title,
            category: data.attributes.category,
            industry: data.attributes.industry || [],
            content_type: data.attributes.content_type,
            goal: data.attributes.goal,
            tone: data.attributes.tone,
            link: data.attributes.link,
            post_type: data.attributes.post_type,
            voice: data.attributes.voice,
            kind: data.attributes.kind,
            prompt: data.attributes.prompt,
            schedule: data.attributes.schedule,
            // image:
            //     imageItem && imageAttributes
            //         ? {
            //               id: imageItem.id,
            //               name: 'image',
            //               original_url: imageAttributes.original_url,
            //               url: imageAttributes.url,
            //               canvas_color: imageAttributes.canvas_color,
            //               visual_settings: imageAttributes.visual_settings,
            //               visual_effects: imageAttributes.visual_effects,
            //               transformation: imageAttributes.transformation,
            //               prompt: imageAttributes.prompt,
            //               is_realism_mode: imageAttributes.is_realism_mode,
            //               reference_settings: imageAttributes.reference_settings,
            //               creativity_level: imageAttributes.creativity_level,
            //           }
            //         : undefined,
        };

        return { project: transformedData, script: scriptAttributes };
    } catch (error) {
        if (axios.isAxiosError(error)) {
            const axiosError = error as AxiosError<{ message: string }>;
            return rejectWithValue(
                axiosError.response?.data.message || 'An error occurred while updating the project',
            );
        }
        return rejectWithValue('An unexpected error occurred');
    }
});
export const uploadDocument = createAsyncThunk<
    { script: ScriptData },
    UploadDocumentPayload,
    { rejectValue: string }
>('documents/uploadDocument', async ({ file, projectId }, { rejectWithValue }) => {
    try {
        if (!file) throw new Error('File is required');
        const formData = new FormData();
        formData.append('file', file);
        formData.append('_method', 'PUT');
        console.log('file', file);
        const response = await axiosInstance.post<DocumentData>(
            `/projects/${projectId}/upload-document`,
            formData,
            {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            },
        );
        console.log('response', response.data);

        const script = response.data.included?.find((item: any) => item.type === 'script_texts');

        return { script: script?.attributes as ScriptData };
    } catch (error) {
        console.log('Error occurred while uploading the document');
        if (axios.isAxiosError(error) && error.response) {
            const axiosError = error as AxiosError<{ message: string }>;
            return rejectWithValue(
                axiosError.response?.data.message || 'Failed to upload document',
            );
        }
        return rejectWithValue('An unexpected error occurred');
    }
});
export const importDocument = createAsyncThunk<
    { script: ScriptData },
    { link: string; projectId: string; accessToken?: string },
    { rejectValue: string }
>('documents/importDocument', async ({ link, projectId, accessToken }, { rejectWithValue }) => {
    try {
        const config = accessToken
            ? { headers: { Authorization: `Bearer ${accessToken}` } }
            : undefined;

        const response = await axiosInstance.put<DocumentData>(
            `/projects/${projectId}/import-document`,
            { link },
            config,
        );

        const script = response.data.included?.find((item: any) => item.type === 'script_texts');

        return { script: script?.attributes as ScriptData };
    } catch (error) {
        console.log('Error occurred while uploading the document');
        if (axios.isAxiosError(error) && error.response) {
            const axiosError = error as AxiosError<{ message: string }>;
            return rejectWithValue(
                axiosError.response?.data.message || 'Failed to upload document',
            );
        }
        return rejectWithValue('An unexpected error occurred');
    }
});

export const refineText = createAsyncThunk<string, RefineTextPayload, { rejectValue: string }>(
    'project/refineText',
    async ({ input, action }, { rejectWithValue }) => {
        try {
            const payload = {
                data: {
                    attributes: {
                        input,
                        action,
                    },
                },
            };

            const response = await axiosInstance.post('/projects/refine/texts', payload);
            const content = response.data?.data?.attributes?.content;

            if (!content || typeof content !== 'string') {
                return rejectWithValue('No content returned');
            }

            return content;
        } catch (error) {
            console.error('Error occurred while refining the text');
            if (axios.isAxiosError(error) && error.response) {
                const axiosError = error as AxiosError<{ message: string }>;
                return rejectWithValue(
                    axiosError.response?.data.message || 'Failed to refine text',
                );
            }
            return rejectWithValue('An unexpected error occurred');
        }
    },
);

export const editPost = createAsyncThunk<string, RefineTextPayload, { rejectValue: string }>(
    'project/editPost',
    async ({ input, action }, { rejectWithValue }) => {
        try {
            const payload = {
                data: {
                    attributes: {
                        input,
                        action,
                    },
                },
            };

            const response = await axiosInstance.post('/projects/edit/post', payload);
            const content = response.data?.data?.attributes?.content;

            if (!content || typeof content !== 'string') {
                return rejectWithValue('No content returned');
            }

            return content;
        } catch (error) {
            console.error('Error occurred while refining the text');
            if (axios.isAxiosError(error) && error.response) {
                const axiosError = error as AxiosError<{ message: string }>;
                return rejectWithValue(
                    axiosError.response?.data.message || 'Failed to refine text',
                );
            }
            return rejectWithValue('An unexpected error occurred');
        }
    },
);

export const fetchProject = createAsyncThunk<
    FetchProjectResult,
    FetchProjectPayload,
    { rejectValue: string }
>('project/fetchProject', async ({ projectId }, { rejectWithValue }) => {
    try {
        const response = await axiosInstance.get<FetchProjectResponse>(`/projects/${projectId}`);

        const { data, included } = response.data;

        const scriptItem = included?.find((item) => item.type === 'script_texts');
        const imageItem = included?.find((item) => item.type === 'image_projects');
        const videoItem = included?.find((item) => item.type === 'videos');

        const scriptData =
            (scriptItem?.attributes as {
                title: string;
                preview: string;
                body: string;
            }) || null;

        const imageData =
            imageItem && imageItem.type === 'image_projects'
                ? {
                      id: imageItem.id,
                      url: imageItem.attributes.image_urls[0] ?? '',
                  }
                : null;

        const videoData =
            videoItem && videoItem.type === 'videos'
                ? {
                      id: videoItem.id,
                      filename: videoItem.attributes.filename ?? '',
                      url: videoItem.attributes.url ?? '',
                  }
                : null;

        const transformedData: CurrentProject = {
            id: data.id,
            title: data.attributes.title,
            prompt: data.attributes.prompt || '',
            category: data.attributes.category,
            industry: data.attributes.industry || [],
            content_type: data.attributes.content_type,
            goal: data.attributes.goal,
            tone: data.attributes.tone,
            link: data.attributes.link,
            voice: data.attributes.voice,
            kind: data.attributes.kind,
            post_type: data.attributes.post_type,
        };

        return { project: transformedData, script: scriptData, image: imageData, video: videoData };
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            const axiosError = error as AxiosError<{ message: string }>;
            return rejectWithValue(axiosError.response?.data.message || 'Failed to fetch project');
        }
        return rejectWithValue('An unexpected error occurred');
    }
});

export const generateContent = createAsyncThunk<
    GeneratedContent,
    { projectId: string; kind: string },
    { rejectValue: string }
>('scripts/generateContent', async ({ projectId, kind }, { rejectWithValue }) => {
    try {
        console.log('kind____________________________________-___', kind);

        const body = {
            data: {
                type: 'content_generations',
                attributes: {
                    for_text: kind === 'text_only' || kind === 'text_image',
                    for_image:
                        kind === 'image_only' || kind === 'multi_image' || kind === 'text_image',
                },
            },
        };

        const response = await axiosInstance.post<GenerateContentResponse>(
            `/projects/${projectId}/generate`,
            body,
        );

        const { data, included } = response.data;
        const scriptText = included.find((item) => item.type === 'script_texts') as {
            id: string;
            attributes: {
                title: string;
                preview: string;
                body: string;
            };
        };
        const image = included.find((item) => item.type === 'image_projects') as {
            id: string;
            attributes: {
                image_urls: string[];
            };
        };

        const transformedData = {
            scriptData: scriptText
                ? {
                      id: scriptText.id,
                      title: scriptText?.attributes?.title ?? 'Untitled',
                      preview: scriptText?.attributes?.preview ?? '',
                      body: scriptText?.attributes?.body ?? '',
                  }
                : null,
            imageData: image
                ? {
                      id: image.id,
                      url: image.attributes.image_urls[0] ?? '',
                  }
                : null,
        };

        return transformedData;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            return rejectWithValue(error.response?.data.message || 'Failed to generate script');
        }
        return rejectWithValue('An unexpected error occurred');
    }
});

export const exportProject = createAsyncThunk<void, string, { rejectValue: string }>(
    'project/exportProject',
    async (projectId, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(`/projects/${projectId}/export`, {
                responseType: 'blob',
            });

            const blob = new Blob([response.data], { type: 'application/pdf' });
            const url = URL.createObjectURL(blob);
            window.open(url);
        } catch (error) {
            if (axios.isAxiosError(error) && error.response) {
                const axiosError = error as AxiosError<{ message: string }>;
                return rejectWithValue(
                    axiosError.response?.data.message || 'Failed to export project',
                );
            }
            return rejectWithValue('An unexpected error occurred');
        }
    },
);

// export const shareProjectOnLinkedIn = createAsyncThunk<
//     void,
//     { projectId: string },
//     { rejectValue: string }
// >('projects/shareOnLinkedIn', async ({ projectId }, { rejectWithValue }) => {
//     try {
//         await axiosInstance.put(`/projects/${projectId}/share/linkedin`);
//     } catch (error) {
//         if (axios.isAxiosError(error) && error.response) {
//             const axiosError = error as AxiosError<{ message: string }>;
//             return rejectWithValue(
//                 axiosError.response?.data.message || 'Failed to share project on LinkedIn',
//             );
//         }
//         return rejectWithValue('An unexpected error occurred');
//     }
// });

// export const shareProjectOnThreads = createAsyncThunk<
//     void,
//     { projectId: string },
//     { rejectValue: string }
// >('projects/shareOnThreads', async ({ projectId }, { rejectWithValue }) => {
//     try {
//         await axiosInstance.put(`/projects/${projectId}/share/threads`);
//     } catch (error) {
//         if (axios.isAxiosError(error) && error.response) {
//             const axiosError = error as AxiosError<{ message: string }>;
//             return rejectWithValue(
//                 axiosError.response?.data.message || 'Failed to share project on Threads',
//             );
//         }
//         return rejectWithValue('An unexpected error occurred');
//     }
// });
export const updateProjectText = createAsyncThunk<
    void,
    UpdateProjectTextPayload,
    { rejectValue: string }
>('projects/updateProjectText', async ({ projectId, body }, { rejectWithValue }) => {
    try {
        const response = await axiosInstance.post(`/projects/${projectId}/texts`, {
            data: {
                type: 'texts',
                attributes: {
                    body,
                },
            },
        });

        console.log('Project text updated successfully:', response.data);
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            const axiosError = error as AxiosError<{ message: string }>;
            return rejectWithValue(
                axiosError.response?.data.message || 'Failed to update project text',
            );
        }
        return rejectWithValue('An unexpected error occurred');
    }
});
export const getRecentProjects = createAsyncThunk<
    RecentProjectsAttributes[],
    string,
    { rejectValue: string }
>('project/getRecentProjects', async (userId, { rejectWithValue }) => {
    try {
        const response = await axiosInstance.get<RecentProjectsApiResponse>(
            `/users/${userId}/projects`,
        );
        const included = response.data.included;

        console.log(response.data);

        const transformedProjects: RecentProjectsAttributes[] = response.data.data.map(
            (project) => {
                const imageItem = included.find(
                    (item) => item.id === project.relationships.image?.id,
                );
                const scriptItem = included.find(
                    (item) => item.id === project.relationships.text?.id,
                );

                return {
                    id: project.id,
                    name: project.attributes.name,
                    title: scriptItem?.attributes.body ?? project.attributes.title,
                    created_at: project.attributes.created_at,
                    prompt: project.attributes.prompt,
                    content_type: project.attributes.content_type,
                    image: {
                        url: imageItem?.attributes?.image_urls?.[0] ?? '',
                    },
                    is_published: project.attributes.is_published ?? false,
                    schedule: {
                        timestamp: project.attributes.schedule?.timestamp ?? '',
                    },
                };
            },
        );

        return transformedProjects;
    } catch (error) {
        console.log('Error occurred while fetching recent projects');
        console.log(error);
        if (axios.isAxiosError(error) && error.response) {
            return rejectWithValue(error.response.data.message);
        }
        return rejectWithValue('An unexpected error occurred');
    }
});

export const deleteProject = createAsyncThunk<void, { projectId: string }, { rejectValue: string }>(
    'projects/deleteProject',
    async ({ projectId }, { rejectWithValue }) => {
        try {
            await axiosInstance.delete(`/projects/${projectId}`);
        } catch (error) {
            if (axios.isAxiosError(error) && error.response) {
                const axiosError = error as AxiosError<{ message: string }>;
                return rejectWithValue(
                    axiosError.response?.data.message || 'Failed to delete project',
                );
            }
            return rejectWithValue('An unexpected error occurred');
        }
    },
);

export const dupicateProject = createAsyncThunk<
    void,
    { projectId: string },
    { rejectValue: string }
>('projects/dupicateProject', async ({ projectId }, { rejectWithValue }) => {
    try {
        await axiosInstance.post(`/projects/${projectId}/duplicate`);
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            const axiosError = error as AxiosError<{ message: string }>;
            return rejectWithValue(axiosError.response?.data.message || 'Failed to delete project');
        }
        return rejectWithValue('An unexpected error occurred');
    }
});

export const shareProject = createAsyncThunk<
    void,
    { projectId: string; pageId?: string },
    { rejectValue: string }
>('projects/shareProject', async ({ projectId, pageId }, { rejectWithValue }) => {
    try {
        console.log('pageId', pageId);
        await axiosInstance.put(`/projects/${projectId}/share`, { pageId });
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            const axiosError = error as AxiosError<{ message: string }>;
            return rejectWithValue(axiosError.response?.data.message || 'Failed to share project');
        }
        return rejectWithValue('An unexpected error occurred');
    }
});

// export const shareProjectOnTiktok = createAsyncThunk<
//     void,
//     { projectId: string },
//     { rejectValue: string }
// >('projects/shareOnTiktok', async ({ projectId }, { rejectWithValue }) => {
//     try {
//         await axiosInstance.put(`/projects/${projectId}/share/tiktok`);
//     } catch (error) {
//         if (axios.isAxiosError(error) && error.response) {
//             const axiosError = error as AxiosError<{ message: string }>;
//             return rejectWithValue(
//                 axiosError.response?.data.message || 'Failed to share project on Tiktok',
//             );
//         }
//         return rejectWithValue('An unexpected error occurred');
//     }
// });
// export const shareProjectOnYoutube = createAsyncThunk<
//     void,
//     { projectId: string },
//     { rejectValue: string }
// >('projects/shareOnYoutube', async ({ projectId }, { rejectWithValue }) => {
//     try {
//         await axiosInstance.put(`/projects/${projectId}/share/youtube`);
//     } catch (error) {
//         if (axios.isAxiosError(error) && error.response) {
//             const axiosError = error as AxiosError<{ message: string }>;
//             return rejectWithValue(
//                 axiosError.response?.data.message || 'Failed to share project on Youtube',
//             );
//         }
//         return rejectWithValue('An unexpected error occurred');
//     }
// });

// export const shareProjectOnPinterest = createAsyncThunk<
//     void,
//     { projectId: string },
//     { rejectValue: string }
// >('projects/shareOnPinterest', async ({ projectId }, { rejectWithValue }) => {
//     try {
//         await axiosInstance.put(`/projects/${projectId}/share/pinterest`);
//     } catch (error) {
//         if (axios.isAxiosError(error) && error.response) {
//             const axiosError = error as AxiosError<{ message: string }>;
//             return rejectWithValue(
//                 axiosError.response?.data.message || 'Failed to share project on Pinterest',
//             );
//         }
//         return rejectWithValue('An unexpected error occurred');
//     }
// });
// export const shareProjectOnFacebook = createAsyncThunk<
//     void,
//     { projectId: string },
//     { rejectValue: string }
// >('projects/shareOnFacebook', async ({ projectId }, { rejectWithValue }) => {
//     try {
//         await axiosInstance.put(`/projects/${projectId}/share/facebook`);
//     } catch (error) {
//         if (axios.isAxiosError(error) && error.response) {
//             const axiosError = error as AxiosError<{ message: string }>;
//             return rejectWithValue(
//                 axiosError.response?.data.message || 'Failed to share project on Facebook',
//             );
//         }
//         return rejectWithValue('An unexpected error occurred');
//     }
// });
// export const shareProjectOnInstagram = createAsyncThunk<
//     void,
//     { projectId: string },
//     { rejectValue: string }
// >('projects/shareOnInstagram', async ({ projectId }, { rejectWithValue }) => {
//     try {
//         await axiosInstance.put(`/projects/${projectId}/share/instagram`);
//     } catch (error) {
//         if (axios.isAxiosError(error) && error.response) {
//             const axiosError = error as AxiosError<{ message: string }>;
//             return rejectWithValue(
//                 axiosError.response?.data.message || 'Failed to share project on Instagram',
//             );
//         }
//         return rejectWithValue('An unexpected error occurred');
//     }
// });
// export const shareProjectOnReddit = createAsyncThunk<
//     void,
//     { projectId: string },
//     { rejectValue: string }
// >('projects/shareOnReddit', async ({ projectId }, { rejectWithValue }) => {
//     try {
//         await axiosInstance.put(`/projects/${projectId}/share/reddit`);
//     } catch (error) {
//         if (axios.isAxiosError(error) && error.response) {
//             const axiosError = error as AxiosError<{ message: string }>;
//             return rejectWithValue(
//                 axiosError.response?.data.message || 'Failed to share project on Reddit',
//             );
//         }
//         return rejectWithValue('An unexpected error occurred');
//     }
// });

export const generateTextSuggestion = createAsyncThunk<
    TextSuggestion[],
    { projectId: string },
    { rejectValue: string }
>('projects/generateTextSuggestion', async ({ projectId }, { rejectWithValue }) => {
    try {
        const res = await axiosInstance.get(`/projects/${projectId}/suggestions`);
        const dataArray = res.data?.data;

        if (!Array.isArray(dataArray) || dataArray.length === 0) {
            return rejectWithValue('No suggestions returned');
        }

        const transformed: TextSuggestion[] = dataArray.map((item, index) => ({
            id: index + 1,
            content: item.attributes?.content || '',
        }));

        return transformed;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            const axiosError = error as AxiosError<{ message: string }>;
            return rejectWithValue(
                axiosError.response?.data.message || 'Failed to generate suggestions',
            );
        }
        return rejectWithValue('An unexpected error occurred');
    }
});

export const searchReference = createAsyncThunk<
    Reference[],
    { projectId: string },
    { rejectValue: string }
>('projects/searchReference', async ({ projectId }, { rejectWithValue }) => {
    try {
        const res = await axiosInstance.get(`/projects/${projectId}/references`);
        const dataArray = res.data?.data;

        if (!Array.isArray(dataArray) || dataArray.length === 0) {
            return rejectWithValue('No suggestions returned');
        }

        const transformed: Reference[] = dataArray.map((item, index) => ({
            id: index + 1,
            url: item.attributes?.url || '',
            last_updated: item.attributes?.last_updated || '',
            date: item.attributes?.date || '',
            title: item.attributes?.title || '',
        }));

        return transformed;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            const axiosError = error as AxiosError<{ message: string }>;
            return rejectWithValue(
                axiosError.response?.data.message || 'Failed to generate suggestions',
            );
        }
        return rejectWithValue('An unexpected error occurred');
    }
});

export const createQuickPost = createAsyncThunk<
    any,
    { platform: string; page_id?: string | null },
    { rejectValue: string }
>('projects/createQuickPost', async ({ platform, page_id }, { rejectWithValue }) => {
    try {
        const response = await axiosInstance.post('/projects/quick-post', {
            data: {
                type: 'social_scrape',
                attributes: {
                    platform,
                    page_id: page_id,
                },
            },
        });

        return response.data.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            const axiosError = error as AxiosError<{ message: string }>;
            return rejectWithValue(
                axiosError.response?.data.message || 'Failed to create quick post',
            );
        }
        return rejectWithValue('An unexpected error occurred');
    }
});

export const createMultiplePosts = createAsyncThunk<
    any[],
    { projectId: string; platform: string },
    { rejectValue: string }
>('projects/createMultiplePosts', async ({ projectId, platform }, { rejectWithValue }) => {
    try {
        const response = await axiosInstance.post(`/projects/${projectId}/multi-post`, {
            data: {
                type: 'multi_post',
                attributes: {
                    platform,
                },
            },
        });

        const included = response.data.included;

        console.log(response.data);

        const transformedProjects: any[] = response.data.data.map((project: any) => {
            const imageItem = included.find(
                (item: any) => item.id === project.relationships.image?.id,
            );
            const scriptItem = included.find(
                (item: any) => item.id === project.relationships.text?.id,
            );

            return {
                id: project.id,
                name: project.attributes.name,
                title: scriptItem?.attributes.body ?? project.attributes.title,
                created_at: project.attributes.created_at,
                prompt: project.attributes.prompt,
                content_type: project.attributes.content_type,
                image: {
                    url: imageItem?.attributes?.image_urls?.[0] ?? '',
                },
                schedule: {
                    timestamp: project.attributes.schedule?.timestamp ?? '',
                    is_published: project.attributes.schedule?.is_published ?? false,
                },
            };
        });

        return transformedProjects;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            const axiosError = error as AxiosError<{ message: string }>;
            return rejectWithValue(
                axiosError.response?.data.message || 'Failed to create multiple posts',
            );
        }
        return rejectWithValue('An unexpected error occurred');
    }
});
